import {ShopCarComponent} from './shop-car.component';

export const shopCarRoutes = [
    {
        path: 'shopCar',
        component: ShopCarComponent
    }
];